import { Field, RHF } from "@devhop/ui";
import type * as React from "react";
import { InfiniteMultiCombobox } from "./InfiniteMultiCombobox";

type FormInfiniteMultiComboboxProps<T> = {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
  queryKey: Array<string>;
  queryFn: (params: {
    search: string;
    pageParam: number;
  }) => Promise<{ items: Array<T>; nextPage: number | null }>;
  preloadQueryFn: (ids: string[]) => Promise<Array<T>>;
  getLabel: (item: T) => string;
  getValue: (item: T) => string;
  placeholder?: string;
  className?: string;
  clearable?: boolean;
  /** ຫຼັງຈາກຄ່າໃນຟອມອັບເດດ (ເຊັ່ນ ຣີເຊັດການກວດສອບ conflict) */
  onFormValueCommit?: () => void;
};

export function FormInfiniteMultiCombobox<T>({
  name,
  label,
  hint,
  requiredMark,
  queryKey,
  queryFn,
  preloadQueryFn,
  getLabel,
  getValue,
  placeholder,
  className,
  clearable,
  onFormValueCommit,
}: FormInfiniteMultiComboboxProps<T>) {
  const { Controller, useFormContext } = RHF;
  const { control } = useFormContext();

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Controller
        control={control}
        name={name as never}
        render={({ field }) => (
          <InfiniteMultiCombobox<T>
            queryKey={queryKey}
            queryFn={queryFn}
            preloadQueryFn={preloadQueryFn}
            getLabel={getLabel}
            getValue={getValue}
            values={Array.isArray(field.value) ? field.value : []}
            onValuesChange={(values) => {
              field.onChange(values);
              onFormValueCommit?.();
            }}
            placeholder={placeholder}
            className={className}
            clearable={clearable}
          />
        )}
      />
    </Field>
  );
}
